module.exports = __webpack_public_path__ + "579bd533dd284dd6e39c43584a18ee58.mp3";